import type { SVGProps } from 'react';

export const Download = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'download'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}>
      <rect height={32} width={32} x={0} y={0} />
      <path
        d="M32,28 L32,30 L0,30 L0,28 L32,28 Z M17,2 L17,18.163 L25.5021667,10 L27,11.4381693 L16,22 L5,11.4381693 L6.49783333,10 L15,18.163 L15,2 L17,2 Z"
        fill={props.fill}
      />
    </g>
  </svg>
);
